export enum TRIGGER_SIGNAL_TYPE {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO',
  DEBUG = 'DEBUG',
  INHIBIT = 'INHIBIT'
}
